<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import EntrIcon from './EntrIcon.vue';

const props = withDefaults(
  defineProps<{
    step: 1 | 2 | 3 | 4;
    canGoBack?: boolean;
    showProgress?: boolean;
  }>(),
  {
    showProgress: true,
  }
);

defineEmits<{
  back: [];
  help: [];
}>();

const { t } = useI18n();
</script>

<template>
  <div class="chrome">
    <button
      class="back"
      :class="{ hidden: !props.canGoBack }"
      type="button"
      :aria-label="t('common.back')"
      data-testid="chrome-back"
      @click="$emit('back')"
    >
      <EntrIcon name="chevron-left" />
    </button>
    <div v-if="props.showProgress" class="dots" aria-hidden="true">
      <span
        v-for="index in 4"
        :key="index"
        class="dot"
        :class="{ active: index === props.step }"
      />
    </div>
    <!-- Help is intentionally hidden for the visitor flow for now. -->
    <!-- <EntrButton variant="ghost" @click="$emit('help')">{{ t('common.help') }}</EntrButton> -->
  </div>
</template>

<style scoped>
.chrome {
  position: absolute;
  z-index: 4;
  left: 0;
  right: 0;
  bottom: 64px;
  height: 96px;
  pointer-events: none;
}

.back {
  position: absolute;
  left: 64px;
  bottom: 0;
  width: 96px;
  height: 96px;
  display: grid;
  place-items: center;
  pointer-events: auto;
}

.back :deep(svg) {
  width: 48px;
  height: 48px;
}

.hidden {
  visibility: hidden;
}

.dots {
  position: absolute;
  left: 50%;
  bottom: 0;
  height: 96px;
  display: flex;
  align-items: center;
  gap: 16px;
  transform: translateX(-50%);
}

.dot {
  width: 16px;
  height: 16px;
  border-radius: 999px;
  background: var(--entr-text-muted);
}

.dot.active {
  background: var(--entr-text);
}
</style>
